
import tableColumns from './models/table.columns';

export const whitelists = {

  serviceAreas: [
    // 'OBJECTID',
    'County',
    'Location',
    // 'ProjectName',
    // 'ProjectType',
    // 'ServiceType',
    'Speeds_mbps',
    // 'Status',
    // 'CompletionDate',
    // 'TargetDate',
    // 'last_edited_date',
  ],

  providers: [
    'ProviderName',
    'Category',
    'URL',
    'PhoneContact',
  ],

};

export function createNormalizedFieldDef(field) {
  return {
    text: field.alias,
    name: field.name,
    value: `attributes.${field.name}`,
    align: 'start', // start | center | end",
    sortable: true,
    divider: false,
    class: '',
    width: null,
    // filter: (value, search, item) => true,
    // sort: (a, b) => Number(0),
  };
}

export const tables = {
  tableColumns,
  whitelists,
  createNormalizedFieldDef,
};

export default tables;
